import $http from './index.js';

export const login= (data)=>{
    return $http.post('api/Login/Login',data)
    // return $http.get('http://jsonplaceholder.typicode.com/posts',data)
}
export const getSchoolList= (data)=>{
    return $http.post('api/School/GetSchoolList',data)
}
export const register= (data)=>{
    return $http.post('api/Register/RegisterUser',data)
}
export const ImportFile= (data)=>{
    return $http.post('api/Register/ImportFile',data)
}
export const GetSTSToken= ()=>{
    return $http.get('api/Heartbeat/GetSTSToken')
}
